var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0069 3.45834L13.4722 12.6528L3.32639 14.1319C1.50695 14.3958 0.777784 16.6389 2.09723 17.9236L9.4375 25.0764L7.70139 35.1806C7.38889 37.0069 9.31251 38.375 10.9236 37.5208L20 32.75L29.0764 37.5208C30.6875 38.3681 32.6111 37.0069 32.2986 35.1806L30.5625 25.0764L37.9028 17.9236C39.2222 16.6389 38.4931 14.3958 36.6736 14.1319L26.5278 12.6528L21.9931 3.45834C21.1806 1.81945 18.8264 1.79861 18.0069 3.45834Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e04fe72ff8862399770f88e4f61683c3.svg";
export { ForwardRef as ReactComponent };